export default __webpack_public_path__ + "static/media/icon_right.e5f46078.svg";